<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-2" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-2">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);">
            <i class="fa fa-exchange text-white"></i>
          </div>
          <div class="header-text-container">
            <h5 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Tipos de Movimentação</h5>
            <p class="text-muted mb-0 small">Pesquisa e gestão de tipos de movimentação</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-2">
            <!-- Search Pill -->
            <div class="d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir/HTML">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarCsv()" v-b-tooltip.hover title="Exportar CSV">
                        <i class="fa fa-file-text-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <b-form-input 
                        type="text" 
                        ref="edDescricao"
                        v-model="descricao" 
                        placeholder="Descrição..." 
                        class="border-0 bg-transparent" 
                        style="width: 200px" 
                        @keydown.enter="pesquisar()" 
                    />
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white"  @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> FILTRAR
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-2"></i>
              <span>Adicionar</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtroAvancado">
          <div class="px-3 pb-2">
              <div class="card card-filter-premium compact-filter p-3 border-0 shadow-sm">
                  <b-row>
                    <b-col sm="2">
                      <label class="small font-weight-bold text-muted mb-1">Código</label>
                      <b-form-input type="text" id="codigo" placeholder="Código" v-model="id" @keydown.enter="pesquisar()"></b-form-input>
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>

      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table 
              class="mb-0 table-finance"
              id="table-tipo-movimentacao"
              ref="tbl"
              :items="itensFiltrados"
              :fields="fieldsListagem"
              :per-page="perPage"
              :current-page="currentPage"
              :sticky-header="stickyHeight"
              :tbody-tr-class="rowClassSelecionado"
              :head-variant="isDark ? 'dark' : 'light'"
              :dark="isDark"
              hover 
              small 
              bordered 
              @row-clicked="clicarLinha"
              @row-dblclicked="edit"
              show-empty
              empty-text="Informe o filtro para ver os registros "
              responsive 
            >
                  
              <template #head(ID)>
                <SetFilter
                  label="ID"
                  v-model="filtros.ID"
                  :options="opcoes.ID"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(DESCRICAO)>
                <SetFilter
                  label="Descrição"
                  v-model="filtros.DESCRICAO"
                  :options="opcoes.DESCRICAO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              
              <template #cell(OP_TIPO_MOVIMENTACAO)="item">
                {{traduzirTipoMovimentacao(item.value)}}
              </template>
              <template #cell(OP_MOVIMENTA_ESTOQUE)="item">
                {{traduzirMovimentaEstoque(item.value)}}
              </template>
              <template #cell(OP_GERA_FINANCEIRO)="item">
                {{traduzirGeraFinanceiro(item.value)}}
              </template>
              <template #cell(OP_DESTINO_OPERACAO)="item">
                {{traduzirDestinoOperacao(item.value)}}
              </template>
              <template #cell(OP_FINALIDADE_EMISSAO)="item">
                {{traduzirFinalidadeEmissao(item.value)}}
              </template>
              <template #cell(GERA_IMPOSTO_ICMS)="item">
                {{item.value === 'S' ? 'Sim' : 'Não'}}
              </template>
              
              <template #empty>
                <div class="h-100 d-flex align-items-center justify-content-center">
                  Nenhum registro encontrado
                </div>
              </template>
              
              <template #cell(actions)="item">
                <div class="d-flex align-items-center gap-1 justify-content-end">
                  <b-button type="button" @click.stop="deleteTipoMovimentacao(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Excluir" v-b-tooltip.hover>
                    <i class="fa fa-times"></i>
                  </b-button>
                </div>
              </template>

              <template #custom-foot="{ fields }">
                <b-tr>
                  <b-td class="font-weight-bold">Total: ({{ itensFiltrados.length }})</b-td>
                  <b-td :colspan="fields.length - 1"></b-td>
                </b-tr>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>
    
    <!-- Modal de Confirmação para Resultados Grandes -->
    <b-modal 
      ref="modalConfirmarResultadoGrande"
      id="modal-confirmar-resultado-grande"
      title="Resultado da Pesquisa"
      header-bg-variant="warning"
      header-text-variant="dark"
      centered
      @ok="confirmarCarregarResultadoGrande"
      @cancel="cancelarCarregarResultadoGrande"
      @shown="onModalShown"
      @hidden="onModalHidden"
      cancel-variant="secondary"
    >
      <div class="text-center">
        <b-icon icon="exclamation-triangle" variant="warning" font-scale="3"></b-icon>
        <h5 class="mt-3">Atenção!</h5>
        <p class="mb-2">
          A pesquisa retornou <strong>{{ resultadoPendenteCount }} registros</strong>.
        </p>
        <p class="mb-0">
          Isso pode deixar o sistema lento.
        </p>
        <p class="mt-3">
          <strong>Deseja continuar mesmo assim?</strong>
        </p>
      </div>
      
      <template #modal-footer="{ cancel, ok }">
        <b-button 
          ref="btnCancelar"
          variant="secondary" 
          @click="cancel()"
        >
          <b-icon icon="x-circle" aria-hidden="true"></b-icon> Não, cancelar [ESC]
        </b-button>
        <b-button 
          variant="primary" 
          @click="ok()"
        >
          <b-icon icon="check-circle" aria-hidden="true"></b-icon> Sim, carregar dados
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import cSwitch from '../../../components/Switch'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import Tools from '@/tools/tools.js'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML'

export default {
  components: {
    VueButtonSpinner,
    cSwitch,
    SetFilter
  },
  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    useExternalPaging: true,
    filters: [
      { key: 'ID', type: 'number', label: 'ID' },
      { key: 'DESCRICAO', type: 'string', label: 'Descrição' }
    ]
  })],

  data () {
    return {
      isBusy: false,
      resultadoPendente: null,
      resultadoPendenteCount: 0,
      modalConfirmacaoAberto: false,
      modalDetails: { index: '', data: '' }
    }
  },
  
  
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
    fieldsListagem: {
      get () {
        return this.$store.getters['tipoMovimentacao/FIELDS']
      }, 
      set (value) {
        this.$store.commit("tipoMovimentacao/SET_FIELDS", value);
      }
    },
    filtroCabecalho: {
      get () {
        return this.$store.getters['tipoMovimentacao/FILTRO_CABECALHO']
      }, 
      set (value) {
        this.$store.commit("tipoMovimentacao/SET_FILTRO_CABECALHO", value);
      }
    },
    currentPage: {
      get () {
        return this.$store.getters['tipoMovimentacao/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("tipoMovimentacao/SET_PAGINA_ATUAL", value);
      }
    },
    filtroAvancado: {
      get () {
        return this.$store.getters['tipoMovimentacao/FILTRO_AVANCADO']
      }, 
      set (value) {
        this.$store.commit("tipoMovimentacao/SET_FILTRO_AVANCADO", value);
      }
    },
    perPage: {
      get () {
        return this.$store.getters['tipoMovimentacao/PER_PAGE']
      }, 
      set (value) {
        this.$store.commit("tipoMovimentacao/SET_PER_PAGE", value);
      }
    },
    id: {
      get () {
        return this.$store.getters['tipoMovimentacao/ID']
      }, 
      set (value) {
        this.$store.commit("tipoMovimentacao/SET_ID", value);
      }
    },
    descricao: {
      get () {
        return this.$store.getters['tipoMovimentacao/DESCRICAO']
      }, 
      set (value) {
        this.$store.commit("tipoMovimentacao/SET_DESCRICAO", value);
      }
    },
    lista: {
      get () {
        return this.$store.getters['tipoMovimentacao/LISTA']
      }, 
      set (value) {
        this.$store.commit("tipoMovimentacao/SET_LISTA", value);
      }
    }
  },
  methods: {
    async deleteTipoMovimentacao(item) {
      const msg = await this.$bvModal.msgBoxConfirm(`Excluir o Tipo de Movimentação: ${item.DESCRICAO} ?`, {
          title: 'Excluir',
          size: 'sm',
          buttonSize: 'xl',
          okVariant: 'danger',
          okTitle: 'SIM',
          cancelTitle: 'NÃO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          noCloseOnEsc: true, 
          noCloseOnBackdrop: true
        })
        
        if (msg == false) return   

        try {
          this.$store.commit('controle/setAguardando', true)
          
          const payload = {
            usuario: window.localStorage.getItem('login'),
            tipoMovimentacaoId: item.ID
          }

          await this.$http.post(`/api/protected/tipoMovimentacao/delete`, payload)

          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Tipo de Movimentação excluído com sucesso!')
          await this.pesquisar()

        } catch(err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err.response?.data || 'Não foi possivel excluir!')
          return
        } finally {
          this.$store.commit('controle/setAguardando', false)
        }
    },
    clicarLinha(item) {
      this.$store.commit("tipoMovimentacao/SET_REGISTRO_SELECIONADO_ID", item.ID)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['tipoMovimentacao/REGISTRO_SELECIONADO_ID']
      return item.ID === selId ? 'cec-row-selected' : ''
    },
    exportarHtml() {
      printHtmlReport({
        rows: this.itensFiltrados,
        reportTitle: 'Listagem de Tipos de Movimentação',
        printedBy: window.localStorage.getItem('login') ?? '—',
        columns: this.fieldsListagem,
        filename: 'tipos-movimentacao.html',
      });
    },
    exportarExcel(){
      exportExcelXlsx ({
        rows: this.itensFiltrados,
        columns: this.fieldsListagem,
        filename: 'tipos-movimentacao.xlsx',
      });
    },
    exportarCsv(){
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.fieldsListagem,
        filename: 'tipos-movimentacao.csv',
      });
    },
    limparFiltro() {
      this.$store.commit("tipoMovimentacao/SET_LIMPAR", null)
    },
    edit (item) {
      this.$store.commit("tipoMovimentacao/SET_REGISTRO_SELECIONADO_ID", item.ID)
      this.$router.push(`/cadastros/tipomovimentacao/edit/${item.ID}`)
    },
    novo () {
      this.$router.push(`/cadastros/tipomovimentacao/add`)
    },
    async pesquisar () {
      if (this.modalConfirmacaoAberto) {
        return
      }
      
      this.isBusy = true
      this.$store.commit('controle/setAguardando', true)
      
      try {
        const resultado = await this.$store.dispatch('tipoMovimentacao/GET_LISTA')
        
        if (resultado.needsConfirmation) {
          this.$store.commit('controle/setAguardando', false)
          this.isBusy = false
          
          this.resultadoPendente = resultado.data
          this.resultadoPendenteCount = resultado.count
          
          if (this.$refs.edDescricao) {
            this.$refs.edDescricao.blur()
          }
          
          this.$refs.modalConfirmarResultadoGrande.show()
          return
        }
        
        if (this.$store.getters['tipoMovimentacao/REGISTRO_SELECIONADO_ID']) {
          this.scrollToSelected()
        }
      } catch(err) {
        this.lista = []
        
        let msg 
        if (err.response && err.response.status) {
          msg = err.response.data
          Tools.exibirMensagem(this.$store, 'Falha', 'warning', msg)
        } else {
          Tools.exibirMensagem(this.$store, 'Falha', 'danger', `Falha ao pesquisar: ${err.message}`)
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
        this.isBusy = false
        this.$nextTick(() => {
          this.$refs.edDescricao?.focus()
        })
      }
    },
    async confirmarCarregarResultadoGrande() {
      this.isBusy = true
      this.$store.commit('controle/setAguardando', true)
      
      try {
        await this.$store.dispatch('tipoMovimentacao/GET_LISTA', { skipConfirmation: true })

        if (this.$store.getters['tipoMovimentacao/REGISTRO_SELECIONADO_ID']) {
          this.scrollToSelected()
        }
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Falha ao carregar os registros: ' + err.message)
      } finally {
        this.$store.commit('controle/setAguardando', false)
        this.isBusy = false
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
        this.$nextTick(() => {
          this.$refs.edDescricao?.focus()
        })
      }
    },
    cancelarCarregarResultadoGrande() {
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
      Tools.exibirMensagem(this.$store, 'Aviso', 'info', 'Pesquisa cancelada. Refine os filtros para reduzir o resultado.')
      this.$nextTick(() => {
        this.$refs.edDescricao?.focus()
      })
    },
    onModalShown() {
      this.modalConfirmacaoAberto = true
    },
    onModalHidden() {
      this.modalConfirmacaoAberto = false
    },
    scrollToSelected() {
      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.querySelector('.cec-row-selected')
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }, 300)
      })
    },
    handleKeydown(event) {
      if (this.modalConfirmacaoAberto) {
        return
      }
      
      if (event.key === "Insert") {
        this.novo()
      } 
    },
    traduzirTipoMovimentacao(valor) {
      const opcoes = { 'S': 'Saída', 'E': 'Entrada' }
      return opcoes[valor] || ''
    },
    traduzirMovimentaEstoque(valor) {
      const opcoes = {
        '0': 'Debitar no Estoque',
        '1': 'Creditar no Estoque',
        '2': 'Creditar (Devolução)'
      }
      return opcoes[valor] || 'Não gerar Op.'
    },
    traduzirGeraFinanceiro(valor) {
      const opcoes = {
        '0': 'Contas a Receber',
        '1': 'Contas a Pagar'
      }
      return opcoes[valor] || 'Não gerar'
    },
    traduzirDestinoOperacao(valor) {
      const opcoes = {
        '1': 'Op. Interna',
        '2': 'Op. Interestadual',
        '3': 'Op. Exterior'
      }
      return opcoes[valor] || ''
    },
    traduzirFinalidadeEmissao(valor) {
      const opcoes = {
        '1': 'NF-e normal',
        '2': 'NF-e complementar',
        '3': 'NF-e de ajuste',
        '4': 'Devolução'
      }
      return opcoes[valor] || ''
    }
  },
  mounted () {
    setTimeout(() => {
      document.addEventListener("keydown", this.handleKeydown)
    }, 200)
    
    this.$nextTick(() => {
      this.$refs.edDescricao?.focus()
    })

    if (this.lista && this.lista.length > 0) {
      this.scrollToSelected()
    }
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown)
  },
}
</script>

<style scoped>
/********************************CABECALHO FIXO***********************/

.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  position: sticky !important;
  top: 0;
  z-index: 2;
  background-clip: padding-box;
}

.b-table-sticky-header .table-responsive {
  max-height: inherit;
  overflow-y: auto;
}

.table.b-table th.b-table-sticky-column,
.table.b-table td.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table th.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table td.b-table-sticky-column {
  z-index: 3;
}

.table.b-table tbody tr.cec-row-selected,
.table.b-table tbody tr.cec-row-selected > td {
  background-color: #c2cfd6  !important;
  color: #000000 !important;
}

.table.b-table tbody tr.cec-row-selected a {
  color: #000000 !important;
}

.table.b-table tbody tr.cec-row-selected td.b-table-sticky-column {
  background-color: #c2cfd6  !important;
}

.table.b-table tbody tr.cec-row-selected:hover > td {
  background-color: #c2cfd6  !important;
}

.table-finance thead th {
  background-color: #f8f9fa !important;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 700;
  color: #495057;
  letter-spacing: 0.5px;
  border-top: none !important;
  border-bottom: 2px solid #dee2e6 !important;
  padding: 4px 6px !important;
}

.table-finance tbody td {
  vertical-align: middle !important;
  padding: 2px 6px !important;
  color: #4a5568;
  font-size: 0.8rem;
}

.table-finance tr:hover {
  background-color: rgba(66, 153, 225, 0.05) !important;
}

.header-icon-wrapper {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.shadow-xs {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
</style>




// WEBPACK FOOTER //
// src/views/cadastros/tipomovimentacao/TipoMovimentacaoListagem.vue